<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card  p-shadow-1">
				<h5>Relógio de Ponto</h5>
                <hr>

                <Toolbar class="p-mb-4">
					<template slot="left">							
                        <div v-if="permissaoNovo">
							<Button label="Gerar Token" icon="pi pi-key" v-if="!tokenGerado" @click="gerarToken" />
						</div>
						<div v-if="tokenGerado">
							<label class="p-mr-3">Token criado em {{ dataTokenGerado }}</label>
							<b>[</b> <a href="#" @click.prevent="buscarToken">Clique aqui para copiar</a> <b>]</b>
						</div>
					</template>
				</Toolbar>

                <DataTable :value="relogios" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-between">	
								<div>
									<Dropdown v-model.number="idCnpjsSelecionado" @change="listarRelogios" :options="cnpjs" 
										optionLabel="cnpjNome" optionValue="id" placeholder="Selecione uma empresa" v-if="tokenGerado"/>
									<Button label="Novo Relógio de Ponto" icon="pi pi-plus" class="p-ml-3" 
										v-if="idCnpjsSelecionado && tokenGerado && permissaoNovo" @click="novo"/>
								</div>			
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
                    <Column field="fabricante" header="Fabricante" sortable></Column>
					<Column field="modelo" header="Modelo" sortable></Column>	
					<Column field="numeroSerie" header="Número de Série" sortable></Column>	
					<Column field="portaria" header="Portaria" sortable></Column>					
					<Column field="dataCadastro" header="Data Cadastro" sortable>
						<template #body="slotProps">
							{{ formatarDataHora(slotProps.data.dataCadastro) }}
						</template>	
					</Column>
					<Column field="dataAutorizacao" header="Data Autorização" sortable>
						<template #body="slotProps">
							{{ formatarDataHora(slotProps.data.dataAutorizacao) }}
						</template>	
					</Column>
					<Column field="localInstalacao" header="Local de Instalação" sortable></Column>	
					<Column field="tipoServico" header="Tipo Serviço" sortable></Column>	
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>			
				</DataTable>

            </div>
        </div>

		<Dialog :visible.sync="exibirDialogNovo" :header="titulo" :modal="true" class="p-fluid" :style="{width: '60vw'}" @hide="fecharModal">
			<div class="p-fluid p-formgrid p-grid">
				<div class="p-field p-col-12">
					<label>Empresa</label>
					<InputText v-model="cnpjSelecionado.cnpjNome" v-if="cnpjSelecionado" readonly/>
				</div>
				<div class="p-field p-col-12">
					<label>Local</label>
					<InputText v-model.trim="relogioPonto.localInstalacao" :readonly="relogioPonto.id != null"/>					
				</div>
				<div class="p-field p-col-4">
					<label>Fabricante</label>
					<Dropdown v-model="relogioPonto.fabricante" :options="fabricantes" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="carregarDefalts('MODELOS')"/>
				</div>
				<div class="p-field p-col-4">
					<label>Modelo</label>
					<Dropdown v-model="relogioPonto.modelo" :options="modelos" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="carregarDefalts('SERVICOS')"/>
				</div>
				<div class="p-field p-col-4">
					<label>Tipo do Serviço de Coleta</label>
					<Dropdown v-model="relogioPonto.tipoServico" :options="tiposServico" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="validarPortariaOpcoesDefault"/>					
				</div>
			</div>

			<div class="p-fluid p-formgrid p-grid" v-if="relogioPonto.fabricante == 'ControlId' && relogioPonto.tipoServico != 'Push Sync'">	
				<div class="p-field p-col-6">
					<label>Número de Série</label>
					<InputText v-model="relogioPonto.numeroSerie"/>					
				</div>
				<div class="p-field p-col-6">									
					<label>Portaria</label>
					<Dropdown v-model="relogioPonto.portaria" :options="portarias" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="validarPortariaOpcoesDefault"/>
				</div>
			</div>
				
			<div class="p-fluid p-formgrid p-grid" 
				v-else-if="relogioPonto.fabricante == 'ControlId' && relogioPonto.modelo == 'ControlId IdFace' && relogioPonto.tipoServico == 'Push Sync'">
				<div class="p-field p-col-4">
					<label>Número de Série</label>
					<InputText v-model="relogioPonto.numeroSerie"/>				
				</div>
				<div class="p-field p-col-4">									
					<label>Portaria</label>
					<Dropdown v-model="relogioPonto.portaria" :options="portarias" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="validarPortariaOpcoesDefault"/>
				</div>	
				<div class="p-field p-col-4" v-if="relogioPonto.tipoServico == 'Push Sync'">
					<label>Id Cloud</label>
					<InputText v-model="idCloud" @keyup="validarSomenteNumeros($event)"/>							
				</div>
			</div>

			<div class="p-fluid p-formgrid p-grid" v-else-if="relogioPonto.fabricante == 'Topdata' && relogioPonto.modelo != 'Leitor Facial F4'">
				<div class="p-field p-col-4">
					<label>Número de Série</label>
					<InputText v-model="relogioPonto.numeroSerie"/>				
				</div>
				<div class="p-field p-col-4">									
					<label>Portaria</label>
					<Dropdown v-model="relogioPonto.portaria" :options="portarias" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="validarPortariaOpcoesDefault"/>
				</div>
				<div class="p-field p-col-4">
					<label style="color: #ffffff">.</label>
					<div class="p-field-checkbox">
						<Checkbox v-model="relogioPonto.integracaoLeitorFacial" :binary="true"/>
						<label>Integração com Leitor Facial</label>
					</div>
				</div>
				<div class="p-field p-col-4" v-if="relogioPonto.integracaoLeitorFacial">
					<label>Número de Série Leitor Facial</label>
					<InputText v-model="relogioPonto.numeroSerieLeitorFacial"/>				
				</div>
			</div>

			<div class="p-fluid p-formgrid p-grid" v-else-if="relogioPonto.fabricante == 'Topdata' && relogioPonto.modelo == 'Leitor Facial F4'">
				<div class="p-field p-col-6">
					<label>Número de Série</label>
					<InputText v-model="relogioPonto.numeroSerie"/>				
				</div>
				<div class="p-field p-col-6">									
					<label>Portaria</label>
					<Dropdown v-model="relogioPonto.portaria" :options="portarias" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="validarPortariaOpcoesDefault"/>
				</div>					
			</div>

			<div class="p-fluid p-formgrid p-grid" v-else-if="relogioPonto.fabricante == 'EVO'">
				<div class="p-field p-col-6">
					<label>Número de Série</label>
					<InputText v-model="relogioPonto.numeroSerie"/>				
				</div>
				<div class="p-field p-col-6">									
					<label>Portaria</label>
					<Dropdown v-model="relogioPonto.portaria" :options="portarias" 
						optionLabel="nome" optionValue="valor" appendTo="body" @change="validarPortariaOpcoesDefault"/>
				</div>					
			</div>

			<div class="p-fluid p-formgrid p-grid">	
				<div class="p-field p-col-12">          
					<Message severity="warn" :closable="false">{{getInfoPortaria(relogioPonto.portaria)}}</Message>
				</div>
				<div class="p-field p-col-12 p-md-12" v-if="relogioPonto.id">
					<Message severity="error" :sticky="true" :closable="false">
						Atenção! <br/>
						Ao atualizar os dados do equipamento, será necessário refazer a autorização/autenticação.
					</Message>
				</div>
			</div>						
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Salvar" icon="pi pi-check" @click="salvar" />
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="fecharModal">
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span>Excluir Relógio de Ponto?</span><br/><br/>
				<label><b>Fabricante</b>: {{ relogioPonto.fabricante }}</label><br/>
				<label><b>Modelo</b>: {{ relogioPonto.modelo }}</label><br/>
				<label><b>Serviço</b>: {{ relogioPonto.tipoServico }}</label><br/>
				<label><b>Número Série</b>: {{ relogioPonto.numeroSerie }}</label>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
			</template>
		</Dialog>

    </div>
</template>

<script>
import RelogioPontoService from '@/service/RelogioPontoService.js';
import RelogioPonto from '@/model/RelogioPonto.js';
import { exibirMensagem, exibirMensagemSis, minTrabPortarias } from '@/global';
import { mapGetters } from 'vuex';

export default {
	relogioPontoService: null,
    data() {
        return {		
            relogios: [],
			cnpjs: [],
			tiposServico: [],
			fabricantes: [
				{nome: 'ControlId', valor: 'ControlId'},
				{nome: 'Topdata', valor: 'Topdata'},
				{nome: 'EVO', valor: 'EVO'}
			],
            modelos: [],
			portarias: minTrabPortarias,
			filtro: {},
			relogioPonto: new RelogioPonto(),
			idCnpjsSelecionado: null,
			cnpjSelecionado: null,
			dataTokenGerado: '',
			titulo: 'Novo Relógio de Ponto',
			exibirDialogNovo: false,
			exibirDialogConfirmarExcluir: false,
			tokenGerado: false,
			enviandoForm: false,			
			idCloud: 0,
        }        
    },
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),
		/**
		 * 
		 */
		carregarDefalts(item) {			
			if('MODELOS' == item) {
				this.modelos = this.getModelos();
				this.tiposServico = [];
				this.relogioPonto.portaria = '';
				this.relogioPonto.modelo = '';
				this.relogioPonto.tipoServico = '';
			} else if('SERVICOS' == item) { 
				this.tiposServico = this.getTiposServicos();
				this.relogioPonto.portaria = '';				
				this.relogioPonto.tipoServico = '';
			}
			this.validarPortariaOpcoesDefault();
		},
		/**
		 * 
		 */
		validarPortariaOpcoesDefault() {
			const modelosDefault = ['ControlId IdFace', 'Leitor Facial F4', 'AIFace'];
			const servicosDefault = ['Push Sync', 'Push Async'];
			if(this.relogioPonto.modelo == modelosDefault[0]) {
				this.relogioPonto.portaria = '1510';
				return;		
			}
			if(this.relogioPonto.modelo == modelosDefault[1] 
				|| this.relogioPonto.modelo == modelosDefault[2]) {				
				this.relogioPonto.portaria = '671';
				this.relogioPonto.tipoServico = servicosDefault[1];
				return;
			}
		},
		/**
		 * Novo relógio.
		 */
		novo() {
			if(this.idCnpjsSelecionado == null) {
				exibirMensagemSis(this, 'Selecione uma empresa', true);
				return;
			}		
			this.titulo = 'Novo Relógio de Ponto';	
			this.exibirDialogNovo = true;
			this.modelos = [];
		},
		/**
		 * Editar relógio.
		 */
		editar(relogio) {
			this.titulo = 'Editar Relógio de Ponto';				
			this.relogioPonto = {...relogio};
			this.modelos = this.getModelos();
			this.tiposServico = this.getTiposServicos();
			this.idCloud = this.relogioPonto.idCloud;
			this.exibirDialogNovo = true;
		},
		/**
		 * Confirmar excluir relógio.
		 */
		confirmarExcluir(relogio) {
			this.relogioPonto = relogio;
			this.exibirDialogConfirmarExcluir = true;
		},
		/**
		 * Salvar/atualiza um relógio.
		 */
		salvar() {
			let requisicao = {
				relogioPonto: this.relogioPonto,
				cnpj: this.cnpjSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.salvar(requisicao)
			.then(resp => {	
				exibirMensagem(this, resp);
				this.fecharModal();
				this.listarRelogios();							
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * Exclui um relógio.
		 */
		excluir() {	
			let requisicao = {
				relogioPonto: {id: this.relogioPonto.id, fabricante: this.relogioPonto.fabricante, numeroSerie: this.relogioPonto.numeroSerie},				
				cnpj: this.cnpjSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.excluir(requisicao)
			.then(resp => {	
				exibirMensagem(this, resp);
				this.fecharModal();
				this.listarRelogios();							
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * Gera o token de autorização.
		 */
		gerarToken() {
			this.relogioPontoService.gerarToken(this.getDadosRequisicao())
			.then(resp => {	
				exibirMensagem(this, resp);
				this.tokenGerado = true;	
				this.verificarTokenGerado();			
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * Prepara o token para área de transferência.
		 */
		async buscarToken() {
			this.relogioPontoService.buscarToken(this.getDadosRequisicao())
			.then(resp => {	
				this.tokenGerado = resp.data.tokenGerado;	
				this.copiar(resp.data.valor);
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * Verificar se o token foi gerado.
		 */
		verificarTokenGerado() {			
			this.relogioPontoService.tokenGerado(this.getDadosRequisicao())
			.then(resp => {	
				this.tokenGerado = resp.data.tokenGerado;	
				this.dataTokenGerado = resp.data.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},		
		/**
		 * Lista os relógios.
		 */
		listarRelogios() {
			if(this.idCnpjsSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }			
			this.cnpjs.forEach(cnpj => {
				if(cnpj.id == this.idCnpjsSelecionado) {
					this.cnpjSelecionado = {...cnpj};
				}
			});
			let requisicao = {
				cnpj: this.cnpjSelecionado,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.listar(requisicao)
			.then(resp => {	
				this.relogios = resp.data;			
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * Lista as empresas/cnpj.
		 */
		listarCnpjs() {
			// Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;  
		},
		/**
		 * Copia o token para área de transferência.
		 */
		async copiar(token) {
			try {
				await navigator.clipboard.writeText(token);
				exibirMensagemSis(this, 'Token copiado', false);
			} catch (err) {
				exibirMensagemSis(this, 'Erro copiar token', true);
				console.error(err);
			}
		},
		/**
		 * 
		 * @param portaria 
		 */
		getInfoPortaria(portaria) {
			if(portaria == '1510') {
				return 'REP Homologado com a Portaria 1510 - Funcionário cadastrado com o PIS';
			} else {// 671
				return 'REP Homologado com a Portaria 671 - Funcionário cadastrado com o CPF';
			}
		},
		/**
		 * Fecha o modal.
		 */
		fecharModal() {
			this.enviandoForm = false;
			this.exibirDialogConfirmarExcluir = false;
			this.exibirDialogNovo = false;
			this.relogioPonto = new RelogioPonto();
		},
		/**
		 * Formata uma data e hora.
		 */
		formatarDataHora(strData) {       
			if(!strData) {
				return '';
			}     
            let partesData = strData.split(' ');
            let camposData = partesData[0].split('-');
            let data = camposData[2]+'/'+camposData[1]+'/'+camposData[0];
            let camposHora = partesData[1].split(':');            
            return data+' '+camposHora[0]+':'+camposHora[1];
        },
		/**
		 * 
		 */
		validarSomenteNumeros() {
			this.idCloud = this.idCloud.replace(/\D/g, '');
			if(this.idCloud) {
				this.relogioPonto.idCloud = Number(this.idCloud);
			}		 
		},
		/**
		 * 
		 */
		getModelos() {
			const fabricante = this.relogioPonto.fabricante;
			const opcoes = [
				{
					fabricante: 'ControlId',
					modelos: [
						{nome: 'ControlId', valor: 'ControlId'}, 
						{nome: 'IdFace', valor: 'ControlId IdFace'}
					]			
				},
				{
					fabricante: 'Topdata',
					modelos: [
						{nome: 'LC', valor: 'LC'}, 
						{nome: 'LFD', valor: 'LFD'}, 
						{nome: 'LM', valor: 'LM'},
						{nome: 'LC Inner Ponto', valor: 'LC Inner Ponto'}, 
						{nome: 'LFD Inner Ponto', valor: 'LFD Inner Ponto'}, 
						{nome: 'LM Inner Ponto', valor: 'LM Inner Ponto'},
						{nome: 'Leitor Facial F4', valor: 'Leitor Facial F4'},
					]								
				},
				{
					fabricante: 'EVO',
					modelos: [
						{nome: 'AIFace', valor: 'AIFace'}
					]			
				},
			]
			return opcoes.find(f => f.fabricante == fabricante).modelos;
		},
		/**
		 * 
		 */
		getTiposServicos() {
			const modelo = this.relogioPonto.modelo;
			const tipos = [				
				{
					modeloRep: 'ControlId IdFace',
					servicos: [
						{nome: 'Nenhum', valor: 'N/D'},
						{nome: 'Coletor Local', valor: 'Coletor Local'},
						{nome: 'Push Sync', valor: 'Push Sync'}							
					]
				},
				{
					modeloRep: 'Leitor Facial F4',
					servicos: [
						{nome: 'Push Async', valor: 'Push Async'}
					]
				},
				{
					modeloRep: 'AIFace',
					servicos: [
						{nome: 'Push Async', valor: 'Push Async'}
					]
				}				
			];
			const item = tipos.find(s => s.modeloRep == modelo);
			if(!item) {
				return [
					{nome: 'Nenhum', valor: 'N/D'},
					{nome: 'Coletor Local', valor: 'Coletor Local'}
				]				
			}
			return item.servicos;
		},
		/**
		 * Valida as permissões.
		 */
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(154);
			this.permissaoEditar = permissoes.includes(155);
			this.permissaoExcluir = permissoes.includes(156);		
		}
	},
	created() {	
		this.relogioPontoService = new RelogioPontoService();
		this.validarPermissoes();
	},
	mounted() {		
		this.verificarTokenGerado();
		this.listarCnpjs();
	}
}
</script>
